import {
  createBrowserRouter,
  Navigate,
  type RouteObject,
  RouterProvider,
} from 'react-router-dom';

import { PasswordLogin } from '../features/auth/PasswordLogin';
import { DashboardView } from '../features/dashboard/DashboardView';
import { BackupListView } from '../features/operations/BackupListView';
import { DeviceHealthView } from '../features/operations/DeviceHealthView';
import { EvidenceVerificationView } from '../features/operations/EvidenceVerificationView';
import { SyncHealthView } from '../features/operations/SyncHealthView';
import { BranchPricingView } from '../features/products/BranchPricingView';
import { CategoriesView } from '../features/products/CategoriesView';
import { ProductFormView } from '../features/products/ProductFormView';
import { ProductImportView } from '../features/products/ProductImportView';
import { ProductListView } from '../features/products/ProductListView';
import { ReconciliationView } from '../features/reconciliation/ReconciliationView';
import { DailySalesView } from '../features/reports/DailySalesView';
import { InventoryReportView } from '../features/reports/InventoryReportView';
import { MonthlySalesView } from '../features/reports/MonthlySalesView';
import { ProductSalesView } from '../features/reports/ProductSalesView';
import { ReceiptHistoryView } from '../features/reports/ReceiptHistoryView';
import { RoundsReportView } from '../features/reports/RoundsReportView';
import { SalesByBranchView } from '../features/reports/SalesByBranchView';
import { VatSummaryView } from '../features/reports/VatSummaryView';
import { ZReportView } from '../features/reports/ZReportView';
import { WholesaleSaleView } from '../features/sales/WholesaleSaleView';
import { AuditLogView } from '../features/settings/AuditLogView';
import { BranchesView } from '../features/settings/BranchesView';
import { PaymentMethodsView } from '../features/settings/PaymentMethodsView';
import { PromotionsView } from '../features/settings/PromotionsView';
import { SystemSettingsView } from '../features/settings/SystemSettingsView';
import { UsersView } from '../features/settings/UsersView';
import { GoodsReceiveView } from '../features/stock/GoodsReceiveView';
import { MovementLogView } from '../features/stock/MovementLogView';
import { StockAdjustView } from '../features/stock/StockAdjustView';
import { StockByBranchView } from '../features/stock/StockByBranchView';
import { TransferCreateView } from '../features/stock/TransferCreateView';
import { TransferDetailView } from '../features/stock/TransferDetailView';
import { TransfersView } from '../features/stock/TransfersView';
import { AuthGuard } from './AuthGuard';
import { Shell } from './layout/Shell';

export const routes: RouteObject[] = [
  { path: '/login', element: <PasswordLogin /> },
  {
    element: (
      <AuthGuard>
        <Shell />
      </AuthGuard>
    ),
    children: [
      { path: '/', element: <DashboardView /> },
      { path: '/sales/wholesale', element: <WholesaleSaleView /> },
      { path: '/reports/daily', element: <DailySalesView /> },
      { path: '/reports/monthly', element: <MonthlySalesView /> },
      { path: '/reports/by-branch', element: <SalesByBranchView /> },
      { path: '/reports/product-sales', element: <ProductSalesView /> },
      { path: '/reports/rounds', element: <RoundsReportView /> },
      { path: '/reports/vat', element: <VatSummaryView /> },
      { path: '/reports/inventory', element: <InventoryReportView /> },
      { path: '/reports/z-report', element: <ZReportView /> },
      {
        path: '/reports/receipts',
        element: <ReceiptHistoryView key="receipt-history" />,
      },
      {
        path: '/tax-invoices',
        element: (
          <ReceiptHistoryView key="tax-invoice-history" mode="tax-invoice" />
        ),
      },
      { path: '/products', element: <ProductListView /> },
      { path: '/products/import', element: <ProductImportView /> },
      { path: '/products/:id', element: <ProductFormView /> },
      { path: '/categories', element: <CategoriesView /> },
      { path: '/pricing', element: <BranchPricingView /> },
      { path: '/stock', element: <StockByBranchView /> },
      { path: '/stock/adjust', element: <StockAdjustView /> },
      { path: '/movements', element: <MovementLogView /> },
      { path: '/transfers', element: <TransfersView /> },
      { path: '/transfers/new', element: <TransferCreateView /> },
      { path: '/transfers/:id', element: <TransferDetailView /> },
      { path: '/goods-receive', element: <GoodsReceiveView /> },
      { path: '/users', element: <UsersView /> },
      { path: '/branches', element: <BranchesView /> },
      { path: '/payment-methods', element: <PaymentMethodsView /> },
      { path: '/promotions', element: <PromotionsView /> },
      { path: '/audit', element: <AuditLogView /> },
      { path: '/settings', element: <SystemSettingsView /> },
      { path: '/operations/sync-health', element: <SyncHealthView /> },
      { path: '/payments/reconciliation', element: <ReconciliationView /> },
      { path: '/payments/evidence', element: <EvidenceVerificationView /> },
      { path: '/devices/health', element: <DeviceHealthView /> },
      { path: '/operations/backups', element: <BackupListView /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
];
const router = createBrowserRouter(routes);
export function AppRouter() {
  return <RouterProvider router={router} />;
}
